import { createFileRoute } from '@tanstack/react-router';
import { IvrPage } from '../../features/settings/components/ivr-page.js';

export const Route = createFileRoute('/admin/ivr')({ component: IvrPage });
